import { FormServFieldType } from '../../../../../shared/types';

export const CUSTOM_FIELDS_LIMIT = 20;

export const CUSTOM_CHOICE_LIMIT = 150;

export const DEFAULT_MANDATORY_FIELDS = ['work_email'];

export const LocalStorageItemKeyForOrder = [
  'contacts-column-order',
  'contact-lists-view-column-order',
  'segments-create-column-order',
];

export const LocalStorageItemKeyForFields = [
  // 'lists-hidden-columns',
  // 'segments-hidden-columns',
  'contacts-hidden-columns',
  'segments-create-hidden-columns',
  'contact-lists-view-hidden-columns',
];

export const hideContactRemoveOptionsFields = ['language'];

export const defaultField: FormServFieldType = {
  id: '',
  label: '',
  name: '',
  position: 0,
  type: 1,
  visible: true,
  required: false,
  editable: true,
  deleted: false,
  internal: false,
  builder: false,
  custom: true,
  validatable: false,
  derived: false,
  field_options: {
    filterable: false,
  },
  placeholder: '',
  fields: [],
  choices: [],
  column_type_blob: false,
  nodegroup_skip: false,
  field_class: '',
  created_at: '',
  updated_at: '',
};
